import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { Label, RequiredAsterisk } from '@atlaskit/form';
import InlineMessage from '@atlaskit/inline-message';
import { ReadOnlyReason } from '../../jira-common/models';
import { useFormSaveQuestionError } from '../controllers/save-errors';
import { ValidationErrorMsg } from '../utils/validation/validationErrorMessages.intl';
import { LinkedFieldIcon } from './linked-field-icon';
import { messages } from './messages';
import { defaultQuestionTypeRendererMap } from './questions';
import { QuestionErrorMsg } from './questions/common/QuestionErrorMsg';
import { QuestionHelperMsg } from './questions/common/QuestionHelperMsg';
import { LabelWrapper } from './questions/common/questionWrappers';
import { UnknownQuestionType } from './questions/unknown-question-type';
import { DisplayMode } from './RenderForm';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LinkedFieldIconWrapper = styled.span({
  marginLeft: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const QuestionLabelWrapper = styled.span({
  display: 'flex'
});
export const RenderQuestion = observer(({
  QuestionRenderer,
  questionTypeRendererMap,
  questionStore,
  displayMode,
  formStore,
  blockFormSubmission,
  linkedFieldNames
}) => {
  var _questionTypeRenderer;
  const intl = useIntl();
  const {
    formQuestion,
    id: questionId,
    issueFieldData,
    revisionToken,
    validationErrors
  } = questionStore;
  const fieldId = `pf-${formStore.formId}-${formQuestion.type}-${questionId}`;
  const formSaveQuestionError = useFormSaveQuestionError(questionId);
  const questionProps = {
    questionStore,
    formStore,
    displayMode,
    id: fieldId,
    revisionToken,
    blockFormSubmission
  };
  const QuestionTypeRenderer = (_questionTypeRenderer = questionTypeRendererMap === null || questionTypeRendererMap === void 0 ? void 0 : questionTypeRendererMap[formQuestion.type]) !== null && _questionTypeRenderer !== void 0 ? _questionTypeRenderer : defaultQuestionTypeRendererMap[formQuestion.type];
  const questionComponent = QuestionTypeRenderer ? /*#__PURE__*/React.createElement(QuestionTypeRenderer, questionProps) : /*#__PURE__*/React.createElement(UnknownQuestionType, {
    questionType: formQuestion.type
  });
  let allQuestionErrors = [];
  if (displayMode === DisplayMode.Edit) {
    allQuestionErrors = [...(validationErrors ? validationErrors : []), ...(formSaveQuestionError ? [{
      key: ValidationErrorMsg.FormSave,
      message: formSaveQuestionError
    }] : [])];
  }
  let warningMessage;
  switch (issueFieldData === null || issueFieldData === void 0 ? void 0 : issueFieldData.readOnlyReason) {
    case ReadOnlyReason.Anonymous:
      warningMessage = messages.readOnlyReasonAnonymousMessage;
      break;
    case ReadOnlyReason.Unlicensed:
      warningMessage = messages.readOnlyReasonUnlicensedMessage;
      break;
    default:
  }
  return QuestionRenderer !== undefined ? /*#__PURE__*/React.createElement(QuestionRenderer, {
    questionId: questionId.toString(),
    fieldId: fieldId,
    formQuestion: formQuestion,
    questionComponent: questionComponent
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelWrapper, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: fieldId,
    id: `label-${fieldId}`
  }, /*#__PURE__*/React.createElement(QuestionLabelWrapper, null, formQuestion.label, formQuestion.validation.rq && /*#__PURE__*/React.createElement(RequiredAsterisk, null), formQuestion.jiraField && linkedFieldNames && /*#__PURE__*/React.createElement(LinkedFieldIconWrapper, null, /*#__PURE__*/React.createElement(LinkedFieldIcon, {
    fieldName: linkedFieldNames === null || linkedFieldNames === void 0 ? void 0 : linkedFieldNames.get(formQuestion.jiraField)
  })))), warningMessage && /*#__PURE__*/React.createElement(InlineMessage, {
    appearance: "connectivity",
    iconLabel: intl.formatMessage(warningMessage)
  }, /*#__PURE__*/React.createElement(FormattedMessage, warningMessage))), /*#__PURE__*/React.createElement(QuestionHelperMsg, {
    description: formQuestion.description
  }), questionComponent, /*#__PURE__*/React.createElement(QuestionErrorMsg, {
    validationErrors: allQuestionErrors.length === 0 ? undefined : allQuestionErrors
  }));
});